import Vue from "vue";
/*
 *图片错误处理
 */
Vue.prototype.$errorImg = e => {
  e.srcElement.src = "../../static/images/home/news-pic1.png";
};
// Vue.prototype.$static = process.argv.splice(3)[0] || ''
Vue.prototype.$static = "https://static.wfq2020.com/data-website/509/";



// WEBPACK FOOTER //
// ./src/utils/util.js